import ExitRouteService, {
    ExitStatus,
} from '../../../Services/ExitRouteService';
import { VoidReturn } from '../../../Utils/PageUtils';
import { WarningDialogHandler } from '../Warning/WarningDialog';

export interface IDeviceCompatibilityCheckDialogProps {
    onClose: () => VoidReturn;
}

function useDeviceCompatibilityCheckDialogHandler(
    props: IDeviceCompatibilityCheckDialogProps
): WarningDialogHandler {
    const { onClose } = props;

    return {
        primaryAction: () => {
            onClose();
            ExitRouteService.exit(ExitStatus.DeviceCompatibilityFail);
        },
    };
}

export default useDeviceCompatibilityCheckDialogHandler;
